export enum FavouriteActionType {
  Add = 'add',
  Remove = 'remove'
}
